import { Component } from 'react';
import styled from 'styled-components';
import { Image } from '../Image/Image';

const SplashElement = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const HeaderElement = styled.div`
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 5px;
`;

const DescriptionElement = styled.div`
  color: ${({ theme }) => theme.vars.newColor.darkGS3};
  font-size: 16px;
`;

interface IProps {
  imageHeight?: number;
  /** Relative url of image to use for the splash. */
  imageUrl: string;
  /** Heading text for the splash. Defaults to "Something went wrong!". */
  heading?: string;
  /** Optional description of the error. Defaults to undefined. */
  description?: string;
}

export class Splash extends Component<IProps> {
  public render() {
    return (
      <SplashElement>
        <Image src={this.props.imageUrl} height={this.props.imageHeight || null} />
        {this.props.heading && <HeaderElement>{this.props.heading}</HeaderElement>}
        {this.props.description && <DescriptionElement>{this.props.description}</DescriptionElement>}
      </SplashElement>
    );
  }
}
